import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentAPI } from 'redux/paymentAPI';
import { SwishRefundRequest } from '@payer-admin-ui/api/src/swish/requests/SwishRefundRequest';
import { ActionState, PaymentIdObject } from '@payer-admin-ui/components-v2/src/types/state';
import { patch } from '@payer-admin-ui/components-v2/src/functions/lodashExtensions';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import { fetchPayment } from '../paymentsGlobalState';

export const refundSwishPayment = createAsyncThunk<void, PaymentIdObject & SwishRefundRequest>(
  'payments/actions/RefundSwishPaymentModal/refund',
  async ({ paymentId, amount, message, externalReferenceId }, { dispatch }) => {
    const result = paymentAPI.actions.refundSwishPayment({
      paymentId,
      amount,
      message,
      externalReferenceId,
    });
    dispatch(fetchPayment({ id: paymentId }));
    dispatch(
      showSnackbar(i18n.t('payments.actions.refundSwishPayment.success', { paymentId }), { severity: 'success' }),
    );
    return result;
  },
);

const refundSwishPaymentModalSlice = createSlice({
  name: 'payments/actions/RefundSwishPaymentModal',
  initialState: {} as ActionState,
  reducers: {
    reset: (state, { payload: { paymentId } }: PayloadAction<PaymentIdObject>) => {
      delete state[paymentId];
    },
  },
  extraReducers: builder => {
    builder.addCase(refundSwishPayment.pending, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: true, success: undefined, error: undefined },
      });
    });
    builder.addCase(refundSwishPayment.fulfilled, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: true, error: undefined },
      });
    });
    builder.addCase(refundSwishPayment.rejected, (state, { meta: { arg }, error }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: false, error },
      });
    });
  },
});

export const {
  actions: { reset },
  reducer: refundSwishPaymentModalReducer,
} = refundSwishPaymentModalSlice;
